import React, {Component} from 'react';
import I18n from 'lib/i18n/i18n';


class AmountItem extends Component {
    constructor(props){
        super(props);
    }

    render() {
        let type = this.props.type;
        return(
            <div className="item1">
                <div className="item-desc1">{I18n.getString(`itemPage::trends::amounts::${type}Desc`)}</div>
                <div className="item-value1">{this.props.value !== undefined ? this.props.value.toLocaleString('en') :  I18n.getString(`itemPage::trends::amounts::total_${type}`)}</div>
                <div className="item-desc-con">{I18n.getString(`itemPage::trends::amounts::${type}DescCon`)}</div>
                <div className="on-worthy">{I18n.getString(`itemPage::trends::amounts::onWorthy`)}</div>
            </div>
        )
    }
}

export default  AmountItem;